import React, { Fragment, Component } from "react";
import * as PropTypes from "prop-types";
import { Modal, Tabs, Table, Button, Tooltip, message, Badge } from "antd";

import moment from "moment";

import { timeCardService } from "../../../redux/services";
import ModalMap from "./ModalMap";
import ModalSelfie from "./ModalSelfie";

class ModalDetails extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			mapModalVisible: false,
			selfieModalVisible: false,
			data: [],
			batidasOcultas: [],
			requestApproving: null,
			requestRejecting: null,
			wasApprovedRequest: false,
		}
	}

	mapOpen = (latitude, longitude, dataHora, fora_perimetro) => {
		this.setState({ mapModalVisible: true });

		// On open screen
		this.mapScreen.onOpen(latitude, longitude, dataHora, fora_perimetro);
	};

	mapOnClose = () => {
		this.setState({ mapModalVisible: false });
	}

	mapOnComplete = () => {
		this.setState({ mapModalVisible: false });
	}

	selfieOpen = (avatar, dataHora) => {
		this.setState({ selfieModalVisible: true });
		// On open screen
		this.selfieScreen.onOpen(avatar, dataHora);
	};

	selfieOnClose = () => {
		this.setState({ selfieModalVisible: false });
	}

	selfieOnComplete = () => {
		this.setState({ selfieModalVisible: false });
	}

	resetFields = () => {
		this.setState({
			data: [],
		});
	};

	fetchSolicitacoesBatidas = () => {
		const { contrato, dataDia, funcionario_id } = this.props;

		if (!contrato || !funcionario_id) return;

		this.setState({ isLoading: true });

		timeCardService.listarSolicitacoesPontoAjuste({
			empresa_id: contrato.empresa_id,
			funcionario_id,
			data_inicio: moment(dataDia).format("YYYY-MM-DD"),
			data_fim: moment(dataDia).format("YYYY-MM-DD"),
		}).then((data) => {
			this.formatPendentes(data.data);
		})
		.catch((data) => {
			this.setState({
				isLoading: false,
			});
			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	}

	fetchBatidas = () => {
		this.setState({
			isLoading: true,
		});

		timeCardService.getDetalhesPonto({
			cartao_ponto_id: this.props.cartaoPontoId,
		})
		.then((response) => {
			this.formatOcultas(response.data.ponto_registros_nao_atribuidos);
			this.formatBatidas(response.data.data);
			this.formatDeletados(response.data.deletados);
			this.formatDuplicados(response.data.duplicados);
			this.fetchSolicitacoesBatidas();
		})
		.catch((data) => {
			this.setState({
				isLoading: false,
			});
			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	}

	formatBatidas = (batidas) => {
		let dataBatidas = [];

		batidas.forEach((batida) => {
			if(batida.ponto_registro_entrada) {
				dataBatidas.push(batida.ponto_registro_entrada);
			}
			if(batida.ponto_registro_saida) {
				dataBatidas.push(batida.ponto_registro_saida);
			}
			if(batida.ponto_ajuste_entrada) {
				dataBatidas.push(batida.ponto_ajuste_entrada);
			}
			if(batida.ponto_ajuste_saida) {
				dataBatidas.push(batida.ponto_ajuste_saida);
			}
		});

		this.setState({
			data: dataBatidas,
			isLoading: false,
		});
	}

	formatDeletados = (deletados) => {
		const { batidasOcultas } = this.state;

		let dataDeletados = [];

		deletados.forEach((batida) => {
			dataDeletados.push(batida);
		});

		this.setState({
			batidasOcultas: [...batidasOcultas, ...dataDeletados],
			isLoading: false,
		});
	}

	formatDuplicados = (duplicados) => {
		const { batidasOcultas } = this.state;

		let dataDuplicados = [];

		duplicados.forEach((batida) => {
			dataDuplicados.push(batida);
		});

		this.setState({
			batidasOcultas: [...batidasOcultas, ...dataDuplicados],
			isLoading: false,
		});
	}

	formatOcultas = (ocultas) => {
		this.setState({
			batidasOcultas: [...ocultas],
			isLoading: false,
		});
	}

	formatPendentes = (pendentes) => {
		const { batidasOcultas } = this.state;

		const requestBatidas = pendentes.map(item => ({
			...item,
			tipo: 'Inclusão (Pendente de Aprovação)',
			origem: 'Manual',
			isRequest: true,
		}))
		this.setState({
			batidasOcultas: [...batidasOcultas, ...requestBatidas],
			isLoading: false,
		})
	}

	updateJustificationRequest = (funcionario_id, empresa_id, solicitacao_id, aprovar) => {
        this.setState({ 
			requestApproving: aprovar ? solicitacao_id : null,
			requestRejecting: !aprovar ? solicitacao_id : null,
		});

        timeCardService.updateSolicitacaoPontoAjuste({
            funcionario_id,
            empresa_id,
            solicitacao_id,
            status_aprovacao: aprovar ? 'aprovado' : 'recusado',
        }).then((data) => {
            message.success(`Solicitação de marcação ${aprovar ? 'aprovada' : 'recusada'} com sucesso!`);
			this.setState({ 
				requestApproving: null,
				requestRejecting: null,
				wasApprovedRequest: aprovar,
			});
			this.fetchBatidas();
        })
        .catch((error) => {
            Modal.error({
                title  : "Ocorreu um erro!",
                content: String(error),
            });
			this.setState({ 
				requestApproving: null,
				requestRejecting: null,
			});
        })
    }

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		if(this.state.wasApprovedRequest) {
			this.props.onComplete(true)
		} else {
			this.props.onClose();
		} 
	};

	onOpen = () => {
		this.fetchBatidas();
	}

	render() {
		const { visible, empresa, departamento, funcionario } = this.props;

		const { isLoading, data, batidasOcultas } = this.state;

		const columns = [
			{
				title: "",
				dataIndex: "",
				key: "alerts",
				render: (_, { online_offline, fora_perimetro }) => (
					<Fragment>
						{online_offline === 0 && (
							<Tooltip placement="top" title="Batida offline">
								<i className="fa fa-exclamation fa-2xs" style={{ color: '#fa7900' }}></i>
							</Tooltip>
						)}
						{fora_perimetro === 1 && (
							<Tooltip placement="top" title="Batida fora do perimetro">
								<i className="fa fa-location fa-2xs" style={{ marginLeft: 10, color: '#ca3f00' }}></i>
							</Tooltip>
						)}
					</Fragment>
				)
			},
			{
				title: "Tipo",
				dataIndex: "tipo",
				key: "tipo",
			},
			{
				title: "Data",
				dataIndex: "data",
				key: "data",
				sorter: (a, b) => moment(a.data).unix() - moment(b.data).unix(),
				defaultSortOrder: 'ascend',
				render: (_, { data }) => {
					return (
						<div>{moment(data).format('DD/MM/YYYY HH:mm:ss')}</div>
					)
				}
			},
			{
				title: "Motivo",
				dataIndex: "motivo",
				key: "motivo",
			},
			{
				title: "Origem",
				dataIndex: "origem",
				key: "origem",
				render: (_, { origem, avatar, latitude, longitude, data, fora_perimetro }) => {
					const avatarExistS3 = 'prod-byponto-files.s3.us-east-1.amazonaws.com';
					return (
						<div style={{ display: "flex", alignItems: "center", gap: 10 }}>
							<span style={{ minWidth: 52 }}>{origem ?? "-"}</span>
							<div className="time-card-list-actions">
								{latitude && longitude && (
									<Tooltip title="Ver localização">
										<Button
											ghost
											type="primary"
											danger={fora_perimetro}
											shape="circle"
											icon={<i className="fal fa-map"></i>}
											onClick={() => this.mapOpen(latitude, longitude, data, fora_perimetro)}
										/>
									</Tooltip>
								)}
								{avatar && avatar.includes(avatarExistS3) && (
									<Tooltip title="Ver foto">
										<Button
											ghost
											type="primary"
											shape="circle"
											icon={<i className="fal fa-portrait"></i>}
											onClick={() => this.selfieOpen(avatar, data)}
										/>
									</Tooltip>
								)}
							</div>
						</div>
					)
				}
			},
			{
				title: 'NSR',
				dataIndex: 'nsr',
				key: 'nsr',
				align: 'center',
				render: (nsr) => nsr ?? '-'
			}
		];

		const hiddenPointColumns = [
			{
				title: "Data",
				dataIndex: "data",
				key: "data",
				sorter: (a, b) => moment(a.data).unix() - moment(b.data).unix(),
				defaultSortOrder: 'ascend',
				render: (_, { data }) => {
					return (
						<div>{moment(data).format('DD/MM/YYYY HH:mm:ss')}</div>
					)
				}
			},
			{
				title: "Tipo",
				dataIndex: "tipo",
				key: "tipo",
			},
			{
				title: "Motivo",
				dataIndex: "motivo",
				key: "motivo",
			},
			{
				title: "Origem",
				dataIndex: "origem",
				key: "origem",
				render: (_, { origem, avatar, latitude, longitude, data, fora_perimetro }) => {
					const avatarExistS3 = 'prod-byponto-files.s3.us-east-1.amazonaws.com';
					return (
						<div style={{ display: "flex", alignItems: "center", gap: 10 }}>
							<span style={{ minWidth: 52 }}>{origem ?? "-"}</span>
							<div className="time-card-list-actions">
								{latitude && longitude && (
									<Tooltip title="Ver localização">
										<Button
											ghost
											type="primary"
											danger={fora_perimetro}
											shape="circle"
											icon={<i className="fal fa-map"></i>}
											onClick={() => this.mapOpen(latitude, longitude, data, fora_perimetro)}
										/>
									</Tooltip>
								)}
								{avatar && avatar.includes(avatarExistS3) && (
									<Tooltip title="Ver foto">
										<Button
											ghost
											type="primary"
											shape="circle"
											icon={<i className="fal fa-portrait"></i>}
											onClick={() => this.selfieOpen(avatar, data)}
										/>
									</Tooltip>
								)}
							</div>
						</div>
					)
				}
			},
			{
				title: 'NSR',
				dataIndex: 'nsr',
				key: 'nsr',
				align: 'center',
				render: (nsr) => nsr ?? '-'
			},
			{
				title: "",
				dataIndex: "isRequest",
				key: "acoes",
				width: 50,
				render: (isRequest, { funcionario_id, contrato, id }) => isRequest ? (
					<div className="time-card-list-actions">
						<Tooltip title="Aprovar">
							<Button
								ghost
								loading={this.state.requestApproving === id}
								disabled={this.state.requestRejecting || this.state.requestApproving}
								style={{ width: '10px' }}
								type="link"
								icon={<i className="fal fa-check"></i>}
								onClick={() => this.updateJustificationRequest(funcionario_id, contrato.empresa_id, id, true)}
							/>
						</Tooltip>
						<Tooltip title="Recusar">
							<Button
								loading={this.state.requestRejecting === id}
								disabled={this.state.requestApproving || this.state.requestRejecting}
								danger
								type="link"
								icon={<i className="fal fa-times"></i>}
								onClick={() => this.updateJustificationRequest(funcionario_id, contrato.empresa_id, id, false)}
							/>
						</Tooltip>
					</div>
				) : '',
			},
		];

		return (
			<Modal
				visible={visible}
				title={(
					<div className="time-card-modal-header">
						<span className="time-card-modal-header-icon"><i className="fal fa-file-alt" /></span>
						<div>
							<div className="time-card-modal-title">
								Detalhes do cartão ponto <span>[{moment(this.props.dataDia).format("DD/MM/YYYY")}]</span>
							</div>
							<div className="time-card-modal-subtitle">Batidas registradas no dia e batidas que ficaram fora do cartão ponto.</div>
						</div>
					</div>
				)}
				wrapClassName="modal-scroll"
				className="time-card-modal"
				destroyOnClose={true}
				width={960}
				onCancel={this.onClose}
				centered
				footer={null}
			>
				<dl className="time-card-modal-info time-card-modal-info-inline">
					<div>
						<dt>Empresa</dt>
						<dd>{empresa ?? "-"}</dd>
					</div>
					<div>
						<dt>Departamento</dt>
						<dd>{departamento ?? "-"}</dd>
					</div>
					<div>
						<dt>Funcionário</dt>
						<dd>{funcionario ?? "-"}</dd>
					</div>
				</dl>
				<div className="time-card-list-card">
					<Tabs defaultActiveKey="batidas">
						<Tabs.TabPane forceRender tab="Batidas" key="batidas">
							<Table className="table-detalhe-batida" loading={{ spinning: isLoading, indicator: <i className="fad fa-spinner-third fa-spin fa-2x" /> }} rowKey="uuid" locale={{ emptyText: 'Nenhuma justificativa cadastrada.' }} columns={columns} dataSource={data ?? []} pagination={false} />
						</Tabs.TabPane>
						<Tabs.TabPane forceRender tab={<span>Batidas fora do cartão ponto{batidasOcultas?.length > 0 && <Badge count={batidasOcultas.length} style={{ backgroundColor: '#f5222d', marginLeft: 8 }} />}</span>} key="batidas_nao_vinculada">
							<Table className="table-detalhe-batida" loading={{ spinning: isLoading, indicator: <i className="fad fa-spinner-third fa-spin fa-2x" /> }} rowKey="uuid" locale={{ emptyText: 'Nenhuma batida desvinculada do cartão ponto.' }} columns={hiddenPointColumns} dataSource={batidasOcultas ?? []} pagination={false} />
						</Tabs.TabPane>
					</Tabs>
				</div>
				<ModalMap
					ref={el => this.mapScreen = el}
					visible={this.state.mapModalVisible}
					onComplete={this.mapOnComplete}
					onClose={this.mapOnClose}
				/>
				<ModalSelfie
					ref={el => this.selfieScreen = el}
					visible={this.state.selfieModalVisible}
					onComplete={this.selfieOnComplete}
					onClose={this.selfieOnClose}
				/>
			</Modal>
		)
	}
}

export default ModalDetails;